import { Component, Input, OnInit, input, viewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  standalone: false,
})
export class TextareaComponent implements OnInit {
  readonly lineCounter = viewChild<HTMLTextAreaElement>('lineCounter');
  readonly textArea = viewChild<HTMLTextAreaElement>('textArea');

  @Input() form?: UntypedFormGroup;
  @Input() controlName = '';

  readonly ejemplo = input('');
  @Input() formato = '';

  public lineCountCache = 0;
  public lineCounterValue = '1.';

  constructor() {}

  public setLineas(lineCount: number): void {
    const outarr = new Array();
    if (this.lineCountCache !== lineCount) {
      for (let x = 0; x < lineCount; x++) {
        outarr[x] = x + 1 + '.';
      }
      this.lineCounterValue = outarr.join('\n');
    }
    this.lineCountCache = lineCount;
  }

  public getErrorMessage(): void {
    if (this.form?.get(this.controlName)?.hasError('error')) {
      return this.form?.get(this.controlName)?.getError('error');
    }
    return;
  }

  public eliminarLineaDelTextArea(linea: string): void {
    const input = this.form?.get(this.controlName)?.value;
    if (input) {
      const lineas = input.split('\n');
      const index = lineas.indexOf(linea);
      if (index > -1) {
        lineas.splice(index, 1);
        this.form?.patchValue({ [this.controlName]: lineas.join('\n') });
      }
      this.onInput();
    }
  }

  public scrollTop(): void {
    const textArea = document.getElementById('textArea');
    if (textArea) {
      textArea.scrollTop = 0;
    }
  }

  public onScroll(): void {
    const textArea = document.getElementById('textArea');
    const lineCounter = document.getElementById('lineCounter');
    if (textArea && lineCounter) {
      lineCounter.scrollTop = textArea.scrollTop;
      lineCounter.scrollLeft = textArea.scrollLeft;
    }
  }

  public onInput(): void {
    const input = this.form?.get(this.controlName)?.value;
    const lineCount = input.split('\n').length || 0;
    this.setLineas(lineCount);
  }

  async ngOnInit(): Promise<void> {}
}
